module.exports = __webpack_public_path__ + "img/about-joined-school-title.2fc4d35c.svg";